export default "__VITE_ASSET__a5795a87__"